import { message } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useAuth } from '../../Contexts/AuthContext';
import { SubscriptionLevel } from '../../Types/SubscriptionLevel';
import { TextService } from '../../Services/TextService';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { EnterpriseFeatureList_SE, FreeFeatureList_SE, PremiumFeatureList_SE, BasicFeatureList_SE } from './features_se';
import { EnterpriseFeatureList_EN, FreeFeatureList_EN, PremiumFeatureList_EN, BasicFeatureList_EN } from './features_en';
import Page from '../../Components/Page/Page';
import { mapSubscriptionLevel } from '../../Mappers/mapSubscriptionLevel';
import { CompanyService } from '../../Services/CompanyService';
import FeatureBoxFree from './FeatureBoxFree';
import FeatureBoxBasic from './FeatureBoxBasic';
import FeatureBoxPremium from './FeatureBoxPremium';
import FeatureBoxEnterprise from './FeatureBoxEnterprise';
import '../Start2/Start2.css';

const Pricing = () => {
  const navigation = useNavigate();
  const { user } = useAuth();
  const GetText = TextService.GetText;

  const redirectToCreateUser = (level: SubscriptionLevel) => {
    if (level === SubscriptionLevel.Free) {
      navigation("/" + getCurrentLanguage() + "/CreateUser");
    }
    else {
      navigation("/" + getCurrentLanguage() + "/CreateUser?subscription=" + mapSubscriptionLevel(level))
    }
  };

  const initiatePayment = async (level: SubscriptionLevel) => {
    if (level === SubscriptionLevel.Free) {
      message.warning("Du måste välja en kontonivå");
      return
    }
    CompanyService.InitiatePayment(level, window.location.href).then(result => {
      window.location.href = result.url!;
    });
  };

  const FreeFeatureList = () => {
    return getCurrentLanguage() == "se" ? FreeFeatureList_SE : FreeFeatureList_EN
  }

  const PremiumFeatureList = () => {
    return getCurrentLanguage() == "se" ? PremiumFeatureList_SE : PremiumFeatureList_EN
  }

  const BasicFeatureList = () => {
    return getCurrentLanguage() == "se" ? BasicFeatureList_SE : BasicFeatureList_EN
  }

  const EnterpriseFeatureList = () => {
    return getCurrentLanguage() == "se" ? EnterpriseFeatureList_SE : EnterpriseFeatureList_EN
  }

  // Styled with the Start2 look (Start2.css) plus pricing-specific rules scoped under .s2-pricing in Pricing.css.
  return <Page className="start2 s2-pricing" pageTitle={GetText("PageTitle_Pricing")}>
    <section className="s2-pricing-head">
      <div className="s2-container">
        <span className="s2-eyebrow">{GetText("Pricing_Title")}</span>
        {getCurrentLanguage() == "se" ? <>
          <h1>Enkla priser som växer med er</h1>
          <p className="s2-lead">Kom igång gratis och uppgradera när ni behöver. Alla priser är per år och exkl. moms.</p>
        </> : <>
          <h1>Simple pricing that grows with you</h1>
          <p className="s2-lead">Get started for free and upgrade when you need to. All prices are per year, excluding VAT.</p>
        </>}
      </div>
    </section>

    <section className="s2-pricing-plans">
      <div className="s2-container">
        <div className="s2-plans">
          <FeatureBoxFree
            user={user}
            description={GetText("Pricing_Free_Description")}
            featureList={FreeFeatureList()}
            redirectToCreateUser={redirectToCreateUser}
          />
          <FeatureBoxBasic
            title={GetText("Pricing_Basic")}
            user={user}
            subscriptionLevel={SubscriptionLevel.Basic}
            pricing={GetText("Pricing_BasicPayment")}
            description1={GetText("Pricing_BasicDescription")}
            mail={"3000-12000 " + GetText("Pricing_EmailYearly")}
            featureList={BasicFeatureList()}
            upgradeToText={GetText("Pricing_UpgradeToBasic")}
            redirectToCreateUser={redirectToCreateUser}
            initiatePayment={initiatePayment}
          />
          <FeatureBoxPremium
            title={GetText("Pricing_Premium")}
            user={user}
            subscriptionLevel={SubscriptionLevel.Premium}
            pricing={GetText("Pricing_PremiumPayment")}
            description={GetText("Pricing_PremiumDescription")}
            mail={"30 000 " + GetText("Pricing_EmailYearly")}
            featureList={PremiumFeatureList()}
            upgradeToText={GetText("Pricing_UpgradeToPremium")}
            redirectToCreateUser={redirectToCreateUser}
            initiatePayment={initiatePayment}
          />
          <FeatureBoxEnterprise
            title={GetText("Pricing_Enterprise")}
            user={user}
            subscriptionLevel={SubscriptionLevel.Enterprise}
            pricing={GetText("Pricing_EnterprisePayment")}
            description={GetText("Pricing_EnterpriseDescription")}
            mail={"60 000-120 000 " + GetText("Pricing_EmailYearly")}
            featureList={EnterpriseFeatureList()}
            upgradeToText={GetText("Pricing_UpgradeToEnterprise")}
            redirectToCreateUser={redirectToCreateUser}
            initiatePayment={initiatePayment}
          />
        </div>
      </div>
    </section>

    <section className="s2-section s2-section-tight">
      <div className="s2-container">
        <div className="s2-pricing-contact">
          <span className="s2-pillar-icon"><MailOutlined /></span>
          <p dangerouslySetInnerHTML={{ __html: GetText("Pricing_ContactUs") }}></p>
        </div>
      </div>
    </section>
  </Page>
};

export default Pricing;